export default __webpack_public_path__ + "static/media/FP_FM_F.c6ae2c4a.png";